/**
 * Single registration: <odx-countdown-timer data-release="ISO8601">
 * Hides day/hour columns when zero (no fade on load; fade when transitioning while visible).
 */
(function () {
  "use strict";

  var FADE_MS = 550;

  function pad2(n) {
    return String(n).padStart(2, "0");
  }

  function OdxCountdownTimer() {
    return HTMLElement.apply(this, arguments);
  }

  OdxCountdownTimer.prototype = Object.create(HTMLElement.prototype);
  OdxCountdownTimer.prototype.constructor = OdxCountdownTimer;

  OdxCountdownTimer.prototype.isCascade = function () {
    return (this.dataset.odxTimerMode || "").trim() === "cascade";
  };

  /** Clear legacy visibility classes so cascade CSS can own layout. */
  OdxCountdownTimer.prototype.clearCascadeGone = function () {
    var keys = ["d", "h", "m", "s"];
    for (var i = 0; i < keys.length; i++) {
      var w = this.getUnitWrap(keys[i]);
      if (w) {
        w.classList.remove("odx-ct-unit--gone", "odx-ct-unit--fading");
      }
    }
  };

  /**
   * One visible unit: ≥24h days only; ≥1h (and <24h) hours only; else minutes only.
   */
  OdxCountdownTimer.prototype.applyCascadeTick = function (diff) {
    this.clearCascadeGone();
    var phase = "m";
    if (diff >= 86400000) phase = "d";
    else if (diff >= 3600000) phase = "h";
    this.setAttribute("data-odx-cascade-phase", phase);

    var dv = Math.floor(diff / 864e5);
    var hv = Math.floor(diff / 36e5);
    var mv = Math.floor(diff / 6e4);
    var sv = Math.floor((diff % 6e4) / 1000);

    if (this.els.d) {
      var ds = dv < 100 ? pad2(dv) : String(dv);
      this.els.d.textContent = ds;
      this.els.d.setAttribute("data-text", ds);
    }
    if (this.els.h) {
      var hs = pad2(hv);
      this.els.h.textContent = hs;
      this.els.h.setAttribute("data-text", hs);
    }
    if (this.els.m) {
      var ms = pad2(mv);
      this.els.m.textContent = ms;
      this.els.m.setAttribute("data-text", ms);
    }
    if (this.els.s) {
      var ss = pad2(sv);
      this.els.s.textContent = ss;
      this.els.s.setAttribute("data-text", ss);
    }
  };

  OdxCountdownTimer.prototype.connectedCallback = function () {
    var releaseStr = (this.dataset.release || "").trim();
    this.tgt = new Date(releaseStr).getTime();
    this.els = {
      d: this.querySelector('[data-val="d"]'),
      h: this.querySelector('[data-val="h"]'),
      m: this.querySelector('[data-val="m"]'),
      s: this.querySelector('[data-val="s"]'),
    };
    this.unitWrap = {
      d: this.querySelector('.timer-unit[data-odx-timer-unit="d"]'),
      h: this.querySelector('.timer-unit[data-odx-timer-unit="h"]'),
      m: this.querySelector('.timer-unit[data-odx-timer-unit="m"]'),
      s: this.querySelector('.timer-unit[data-odx-timer-unit="s"]'),
    };
    if (!this.els.d || isNaN(this.tgt)) {
      this.setAttribute("data-odx-timer-issue", "invalid-release");
      this.setAttribute("data-odx-timer-raw", releaseStr || "(empty)");
      return;
    }
    this._sawFutureCountdown = false;
    this._prevD = null;
    this._prevH = null;
    this._initialVisibilityDone = false;
    this.syncDataText();
    var diff0 = this.tgt - Date.now();
    if (this.isCascade()) {
      if (!isNaN(diff0) && diff0 > 0) {
        this.applyCascadeTick(diff0);
      }
      this._initialVisibilityDone = true;
    } else {
      this.applyInitialUnitVisibility(diff0);
      this._initialVisibilityDone = true;
    }
    this.tick();
    this.inv = setInterval(this.tick.bind(this), 1000);
  };

  OdxCountdownTimer.prototype.syncDataText = function () {
    var arr = [this.els.d, this.els.h, this.els.m, this.els.s];
    for (var i = 0; i < arr.length; i++) {
      var el = arr[i];
      if (el) el.setAttribute("data-text", el.textContent || "00");
    }
  };

  OdxCountdownTimer.prototype.getUnitWrap = function (key) {
    return (
      this.unitWrap[key] ||
      (this.els[key] && this.els[key].closest
        ? this.els[key].closest(".timer-unit")
        : null)
    );
  };

  /** @param fade {boolean} */
  OdxCountdownTimer.prototype.hideUnit = function (key, fade) {
    var wrap = this.getUnitWrap(key);
    if (!wrap || wrap.classList.contains("odx-ct-unit--gone")) return;
    if (fade) {
      wrap.classList.add("odx-ct-unit--fading");
      var self = this;
      setTimeout(function () {
        wrap.classList.remove("odx-ct-unit--fading");
        wrap.classList.add("odx-ct-unit--gone");
      }, FADE_MS);
    } else {
      wrap.classList.add("odx-ct-unit--gone");
    }
  };

  OdxCountdownTimer.prototype.applyInitialUnitVisibility = function (diff) {
    if (isNaN(diff) || diff <= 0) return;
    var dv = Math.floor(diff / 864e5);
    var hv = Math.floor((diff % 864e5) / 36e5);
    if (dv === 0) this.hideUnit("d", false);
    if (hv === 0) this.hideUnit("h", false);
  };

  OdxCountdownTimer.prototype.tick = function () {
    var diff = this.tgt - Date.now();
    if (isNaN(diff) || diff <= 0) {
      if (this.inv) clearInterval(this.inv);
      this.setAttribute("data-odx-timer-issue", "target-past");
      this.setAttribute("data-odx-timer-raw", this.dataset.release || "(empty)");
      if (diff <= 0) {
        this.innerHTML =
          '<span style="color:#00ff00;text-shadow:0 0 10px #00ff00;">UNLOCKED</span>';
        if (
          this._sawFutureCountdown &&
          (typeof Shopify === "undefined" || !Shopify.designMode)
        ) {
          var self = this;
          setTimeout(function () {
            location.reload();
          }, 3000);
        }
      }
      return;
    }

    if (this.isCascade()) {
      this.applyCascadeTick(diff);
      this._sawFutureCountdown = true;
      this.syncDataText();
      return;
    }

    var dv = Math.floor(diff / 864e5);
    var hv = Math.floor((diff % 864e5) / 36e5);
    var mv = Math.floor((diff % 36e5) / 6e4);
    var sv = Math.floor((diff % 6e4) / 1000);

    if (this._initialVisibilityDone) {
      if (this._prevD !== null && this._prevD > 0 && dv === 0) {
        this.hideUnit("d", true);
      }
      if (this._prevH !== null && this._prevH > 0 && hv === 0) {
        this.hideUnit("h", true);
      }
    }

    this._prevD = dv;
    this._prevH = hv;

    var wd = this.getUnitWrap("d");
    var wh = this.getUnitWrap("h");
    if (this.els.d && wd && !wd.classList.contains("odx-ct-unit--gone")) {
      var ds = pad2(dv);
      this.els.d.textContent = ds;
      this.els.d.setAttribute("data-text", ds);
    }
    if (this.els.h && wh && !wh.classList.contains("odx-ct-unit--gone")) {
      var hs = pad2(hv);
      this.els.h.textContent = hs;
      this.els.h.setAttribute("data-text", hs);
    }
    if (this.els.m) {
      var ms = pad2(mv);
      this.els.m.textContent = ms;
      this.els.m.setAttribute("data-text", ms);
    }
    if (this.els.s) {
      var ss = pad2(sv);
      this.els.s.textContent = ss;
      this.els.s.setAttribute("data-text", ss);
    }

    this._sawFutureCountdown = true;
    this.syncDataText();
  };

  OdxCountdownTimer.prototype.disconnectedCallback = function () {
    if (this.inv) clearInterval(this.inv);
  };

  if (!customElements.get("odx-countdown-timer")) {
    customElements.define("odx-countdown-timer", OdxCountdownTimer);
  }
})();
